import PaymentAdminFirstPage from "./PaymentByAdmin/PaymentAdminFirstPage";
import React from "react";

const PayByAdmin = ({ id, interval }) => {
  return <PaymentAdminFirstPage paymentId={id} interval={interval} />;
};

export default PayByAdmin;
